import { RootState, TypedDispatch } from "../../../../../../redux/store";
import { connect } from "react-redux";
import { PaymentCartStateDTO } from "../service/types";
import { getCartInfo, initiatePayment } from "../service/paymentCartSlice";
import PaymentCart from "../payemntCartComponents/PaymentCart";
import PaymentSuccessfull from "../payemntCartComponents/PaymentSuccessfull";

interface StateProps extends PaymentCartStateDTO {}

interface DispatchProps {
  GetPaymentCartInfoById(data: string): void;
  InitiatePayment(data: any): void;
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    success: state.paymentCart.success,
    error: state.paymentCart.error,
    loading: state.paymentCart.loading,
    data: state.paymentCart.data,
    paymentInitiateLoading: state.paymentCart.paymentInitiateLoading,
    paymentInitiateSuccess: state.paymentCart.paymentInitiateSuccess,
    paymentInitiateError: state.paymentCart.paymentInitiateError,
    paymentInitiateData: state.paymentCart.paymentInitiateData,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    GetPaymentCartInfoById: (data: any) => {
      dispatch(getCartInfo(data));
    },
    InitiatePayment: (data: any) => {
      dispatch(initiatePayment(data));
    },
  };
};
export interface PaymentCartProps extends StateProps, DispatchProps {}
export const PaymentCartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentCart);

export const PaymentSuccessfullComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentSuccessfull);
